import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yv36hmng6n: FaireBrandEntity = {
  token: "b_yv36hmng6n",
  type: "brand",
  name: "Gem Avenue Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/497248fb622a78e1dd1303d7de652652b6a56727b518fc9aef760e531d5da524.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4d70cab8e0bc61cee5daad2a64aafa8f409ba616d919d5dce7a091fb91c2f921.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/497248fb622a78e1dd1303d7de652652b6a56727b518fc9aef760e531d5da524.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4d70cab8e0bc61cee5daad2a64aafa8f409ba616d919d5dce7a091fb91c2f921.jpeg",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 69,
  rating: 4.8,
  reviewCount: 32,
  isInsider: true,
  description:
    "Gem Avenue Rock Shop is a family-owned and operated wholesale crystal distributor located in Charlotte, North Carolina. We specialize in rocks, minerals, crystals, and gems from all around the globe at low prices. Customer service is our top priority, and all items ship from the USA. Our team works closely with cutters and mines globally to offer our customers a wide variety of stone products for home décor, jewelry making, meditation practices, and resale. We take pride in our ability to provide high-quality items at affordable prices. With unbeatable wholesale pricing on bulk orders for businesses in need of exceptional crystal products, Gem Avenue Rock Shop is your destination for unique pieces you can trust.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:00.846Z",
    importedBy: "entity-db-cli",
  },
};
